import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";
import { lazy } from "react";

const OffersPageContent = lazy(() => import("./OffersPageContent"));

function OffersPageInternal() {
    return (
        <DefaultPage>
            <OffersPageContent />
        </DefaultPage>
    );
}

export const OffersPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN))(OffersPageInternal);
